import React, {PropTypes} from 'react';
import { FormattedMessage } from 'react-intl';

import { defaultUnitFieldValues } from 'app/businessRules';
import setFormData from 'app/lib/setFormData';
import resetForm from 'app/lib/resetForm';
import Table from 'routes/app/components/Table';
import Button from 'routes/app/components/Button';
import Icon from 'routes/app/components/Icon';
import Modal from 'routes/app/components/Modal';
import TableActions from 'routes/app/components/TableActions';
import DocsDetailModal from './DocsDetailModal';



class DocsTable extends React.Component {
    static propTypes = {
        docs: PropTypes.array.isRequired,
        docForm: PropTypes.object.isRequired,
        docTypes: PropTypes.array.isRequired,
        removeDoc: PropTypes.func,
        packUnity: PropTypes.array,
        translate: PropTypes.func,
        saveDoc: PropTypes.func,
        getDocs: PropTypes.func
    };

    componentWillReceiveProps(nextProps) {
        if (this.newDocsFound(nextProps)) {
            this.updateIdInForm(nextProps.docForm, this.getIdOfLastDoc(nextProps.docs));
        }
    }

    updateIdInForm = (form, id) => {
        form.id.onChange(id);
    };

    newDocsFound = (nextProps) => {
        return nextProps.docs.length > this.props.docs.length;
    };

    getIdOfLastDoc = (docs) => {
        return docs[docs.length-1].id;
    };

    render() {
        const {docs, docForm, docTypes, removeDoc, saveDoc, packUnity, translate, getDocs} = this.props;

        const openForm = () => docForm.open.onChange(true);
        const closeForm = () => getDocs() && docForm.open.onChange(false);

        return (
            <ul className="collection with-header">
                <li className="collection-header">
                    <h2><FormattedMessage id="unit.heading.docsOverview"/></h2>

                    {/*<Button floating onClick={addDoc}><Icon>add</Icon></Button>*/}
                    <DocsDetailModal
                        packUnity={packUnity}
                        translate={translate}
                        fields={docForm}
                        docTypes={docTypes}
                        onClickAgree={saveDoc}
                        onClickDisagree={closeForm}
                    >
                        <Button floating onClick={()=>{resetForm(docForm, defaultUnitFieldValues.doc);openForm();}}><Icon>add</Icon></Button>
                    </DocsDetailModal>
                </li>
                <li>
                    <Table className="with-actions" striped responsive-table>
                        <thead>
                        <tr>
                            <th><FormattedMessage id="doc.type" /></th>
                            <th><FormattedMessage id="doc.number" /></th>
                        </tr>
                        </thead>
                        <tbody>
                        {docs.length === 0 &&
                        <tr>
                            <td colSpan="4"><FormattedMessage id="unit.docs.noDocs" /></td>
                        </tr>
                        }
                        {docs.length > 0 && docs.map((doc, index) =>
                            /*index < docs.length - 1 &&*/
                            <tr key={index}>
                                <td>{doc.type}</td>
                                <td>{doc.number}</td>

                                <td className="table-actions" style={{width: 90}}>
                                    <DocsDetailModal
                                        packUnity={packUnity}
                                        translate={translate}
                                        fields={docForm}
                                        docTypes={docTypes}
                                        onClickAgree={saveDoc}
                                        onClickDisagree={closeForm}
                                        attachments={doc.attachments}
                                    >
                                        <Button className="table-actions__edit" onClick={()=>{setFormData(docForm,doc,defaultUnitFieldValues.doc);openForm();}}><i
                                            className="material-icons">mode_edit</i></Button>
                                    </DocsDetailModal>

                                    <Modal
                                        header={translate({id:'unit.docs.remove.confirm.title'})}
                                        onClickAgree={()=>{removeDoc(doc.id);}}
                                        textDisagree={translate({id:'unit.docs.remove.confirm.btnCancel'})}
                                        textAgree={translate({id:'unit.docs.remove.confirm.btnOK'})}
                                        trigger={
                                            <Button className="table-actions__remove">
                                                <i className="material-icons">delete</i>
                                            </Button>
                                        }>
                                        <p>{translate({id:'unit.docs.remove.confirm'})}</p>
                                    </Modal>

                                </td>
                            </tr>
                        )}
                        </tbody>
                    </Table>
                </li>
            </ul>
        );
    }
}

export default DocsTable;